import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { WeblinkAttachment } from '../shared/weblink-attachment/weblink-attachment';
import { EditableFault } from '../shared/editable-fault/editable-fault';
import { WeblinkFaultService } from '../shared/weblink-fault.service';



@Component({
  selector: 'app-weblink-attachment-list',
  templateUrl: './weblink-attachment-list.component.html',
  styleUrls: ['./weblink-attachment-list.component.scss']
})
export class WeblinkAttachmentListComponent implements OnInit,OnChanges,OnDestroy {

  mouseOvered: boolean = false;
  canPrevious: boolean = false;
  canShow:boolean=false;
  canNext: boolean = false;
  canDownload: boolean= false;
  currentUrl: SafeUrl= this.no_imageUrl;
  currentAttachement: WeblinkAttachment;
  countText: string;
  title:string;
  loading: boolean = true;
  hasImages: boolean = true;
  subscription:Subscription= new Subscription();
  @Input() fault: EditableFault;
  @Output() attachmentClick: EventEmitter<number> = new EventEmitter<number>();

  @Input() modal:boolean=false;
  @Input() isModalOpened:boolean=false;

  constructor(private faultService: WeblinkFaultService) {
    this.subscription.add(
      this.faultService.attachmentAdded.subscribe(event=>{
        if (event.fault && this.fault && event.fault.Id== this.fault.Id){
          this.showAttachment(event.attachment);
        }
      })
    );
   }

  ngOnChanges (simpleChanges: SimpleChanges){

  }


  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
  ngOnInit() {
    this.initialize();
  }

  initialize() {
    let attachment;
    this.currentUrl= this.no_imageUrl;
    if (this.fault) {

      if (!this.fault.Files)
        this.fault.Files= [];

      if (this.fault.currentAttachmentId)
          attachment= this.fault.Files.find(at=>at.Id==this.fault.currentAttachmentId);

      if (!attachment && this.fault.Files.length > 0) attachment = this.fault.Files[this.fault.Files.length - 1];

      if (!attachment){
        const v = this.fault.Data.find((obj) => obj.Key === 'LastImage');
        if (v && v.Val ) {
          const a=this.fault.Files.find(at => at.Id == v.Val)
          attachment = a?a:null;
        }
      }

      if (attachment) {
        this.showAttachment(attachment);
      }
    }
    if (!attachment) {

        //this.currentThumbnailUrl = "./assets/no_image.png"
        this.hasImages = false;
        this.canShow= false;
        this.loading = false;
      }
    }

    get no_imageUrl(): string{
      return "./assets/no_image.svg";
    }
    get error_imageUrl():string {
      return"./assets/error_image.svg";
    }


    getCurrentIndex():number{
      return  this.fault.Files.findIndex(at => at.Id == this.fault.currentAttachmentId);
    }


    select(){
      const i=this.getCurrentIndex();
      if (i<0) return;

      this.attachmentClick.emit(this.fault.Files[i].Id);

    }
    showNext() {
      let i = this.getCurrentIndex();
      if (i == -1 || this.fault.Files.length<2 ) return;
      i=i+1;
      if (i == this.fault.Files.length) i=0;
      this.showAttachment(this.fault.Files[i]);
    }

    showPrevious() {
      let i = this.getCurrentIndex();
      if (i == -1 || this.fault.Files.length<2 ) return;
      i=i-1;
      if (i < 0) i=this.fault.Files.length-1;
      this.showAttachment(this.fault.Files[i]);
    }

    closeModal(){
        this.isModalOpened = false;
        this.currentUrl= null;
    }

    download(){
      if (!this.currentAttachement) return;
      var attachment= this.currentAttachement;
      if (!attachment) return;

      this.canNext = false;
      this.canPrevious = false;
      this.loading = true;

      let  scopedWindow = window;

      this.faultService.getWeblinkAttachment(attachment.Id).subscribe(file => {

        attachment.File=file;
        this.loading = false;
        this.setButtons();

        if ((window.navigator as any).msSaveOrOpenBlob){
          (window.navigator as any).msSaveOrOpenBlob(attachment.File.b, attachment.FileName);
        } else {
          const anchor = document.createElement('a');
          //anchor.target='_blank';
          anchor.download = attachment.FileName;
          anchor.href = file.u;
          anchor.type = attachment.MimeType;
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);

        }

      },
        error => {
          //show error image

          this.canShow= false;
          this.currentUrl = this.error_imageUrl;

          this.loading = false;
          this.setButtons()

        });

    }

  private showAttachment(attachment: WeblinkAttachment) {
    this.canNext = false;
    this.canPrevious = false;
    this.hasImages= true;
    this.fault.currentAttachmentId =attachment.Id;
    this.title = attachment.Description ? attachment.Description : attachment.FileName ;
    this.loading = true;
    this.canDownload= false;
    this.currentAttachement= attachment;

    const height= this.modal && attachment.Type==0 && attachment.MimeType!="image/tiff" ? 0: 240;
    const width=height;

    this.faultService.getWeblinkAttachment(attachment.Id,height,width).subscribe(file => {

      if (file.MimeType.startsWith("image") && file.MimeType!="image/tiff" ){
        this.currentUrl = file.Url;
        this.canShow= true;
      }else if (file.MimeType.startsWith("application/pdf")){
        this.currentUrl = "./assets/file-pdf.svg";
        this.canShow= false;
      }else {
        this.currentUrl = "./assets/file.svg";
        this.canShow= false;
      }

      this.canDownload= this.modal && (attachment.Type!=0 || attachment.MimeType=="image/tiff" );

      this.loading = false;
      this.setButtons();

    },
      error => {
        //show error image

        this.canShow= false;
        this.currentUrl = this.error_imageUrl;

        this.loading = false;
        this.setButtons();

      });
  }



  private setButtons() {
    if (!this.fault.currentAttachmentId) {
      this.canNext = false;
      this.canPrevious = false;
      this.countText = "";
      return;
    }
    const i = this.getCurrentIndex();
    if (i == -1) {
      this.canNext = false;
      this.canPrevious = false;
      this.countText = "";
      return;
    }
    this.countText = (i + 1).toString() + "/" + this.fault.Files.length.toString();
    this.canNext = this.fault.Files.length >1;
    this.canPrevious = this.fault.Files.length >1;
  }

}
